var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataList)?_c('div',{staticClass:"sub-message-list"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index},[_c('span',[_vm._v("【"+_vm._s(item.status)+"】"+_vm._s(item.time || '')+" "+_vm._s(item.location||''))]),_c('br'),_c('span',[_vm._v(_vm._s(item.context || ''))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }